/** The SDICS Field app for chiefs and registration officers (Flutter build,
 *  mobile-flutter/). Each release is copied to /var/www/sdics/downloads/ on
 *  the server; bump this when publishing a new one. */
export const FIELD_APK = { href: '/downloads/SDICS-Field-v2.2.0.apk', version: '2.2.0' };
